import { render, staticRenderFns } from "./RecognitionBadge.vue?vue&type=template&id=f1662ed6&scoped=true"
import script from "./RecognitionBadge.vue?vue&type=script&lang=js"
export * from "./RecognitionBadge.vue?vue&type=script&lang=js"
import style0 from "./RecognitionBadge.vue?vue&type=style&index=0&id=f1662ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1662ed6",
  null
  
)

export default component.exports